<div class="m-0">
    <div class="bg-primary mb-4 text-center p-2">
        <h1 class="text-ligth fw-bold mb-0">Información de {{ textDinamico }}</h1>
    </div>
    <div class="card-body">
        <div class="card border-0 mb-3">
            <div class="text-center">
                <img class="img-fluid top-radius-blog" [src]="data.vc_photo_event || data.vc_photo_offer" [alt]="'Imagen del evento ' + data.vc_tittle_offer || data.vc_tittle_offer" />
                <div class="blog-details-main mt-3">
                    <ul class="event-meta-list d-flex flex-wrap gap-3">
                        <li class="digits"><i class="fas fa-calendar-alt mr-2 text-primary"></i>&nbsp;{{ data.date?.[0]?.vc_start_date | date: 'fullDate' | titlecase }} a las {{ data.date?.[0]?.vc_start_hour }}</li>
                        <li class="digits"><i class="fas fa-users mr-2 text-primary"></i>&nbsp;{{ data.subscribers }} Inscritos</li>
                        <li class="digits">
                            <i class="far fa-user mr-2 text-primary"></i>&nbsp;<a
                                aria-label="Nombre de Usuario"
                                class="seleccionable"
                                [attr.aria-label]="'Ver perfil de ' + data.vc_user"
                                tabindex="0"
                                (click)="setUrlProfile(data.profile?.profile_url)"
                                (keydown.enter)="setUrlProfile(data.profile?.profile_url)"
                                >{{ data.profile?.vc_username }}</a
                            >
                        </li>
                    </ul>
                </div>
                <hr />
                <h2 class="fw-bold text-primary">{{ data.vc_tittle_event || data.vc_tittle_offer }}</h2>
                <p class="fw-light">{{ data.vc_subtitle_event || data.vc_subtitle_offer }}</p>
                <div *ngIf="data.vc_description_event || data.vc_description_offer" class="mt-4">
                    <p class="px-4">{{ data.vc_description_event || data.vc_description_offer }}</p>
                </div>
            </div>
            <div class="event-actions d-flex justify-content-around align-items-center flex-wrap gap-3 mt-3">
                <!-- Calificación -->
                <div class="d-flex align-items-center gap-2">
                    <h3 class="m-0">Calificación:</h3>

                    <ng-template #t let-fill="fill">
                        <span class="star" style="color: #afb6aff3; position: relative; display: inline-block" [class.full]="fill === 100">
                            <span class="half text-primary" style="position: absolute; overflow: hidden; top: 0; left: 0" [style.width.%]="fill">&#9733;</span>&#9733;
                        </span>
                    </ng-template>

                    <ngb-rating aria-label="Calificación" [(rate)]="rating" [starTemplate]="t" [max]="5" (hover)="isRating = true; hovered = $event" (leave)="isRating = false; hovered = 0" (rateChange)="onRateChange($event)"> </ngb-rating>
                </div>

                <!-- Botón -->
                <div>
                    <button *ngIf="!inscritoData" class="btn btn-sm btn-outline-primary" (click)="saveInscripcion()">
                        <i class="far fa-check-square me-1"></i>
                        <span class="d-none d-md-inline">Inscribirse</span>
                    </button>

                    <button *ngIf="inscritoData" class="btn btn-sm btn-outline-danger" (click)="deleteInscripcion()">
                        <i class="fas fa-times-circle me-1"></i>
                        <span class="d-none d-md-inline">Cancelar inscripción</span>
                    </button>
                </div>
            </div>
        </div>
        <hr />
        <div class="event-grid">
            <!--<div class="event-section">
                <h6 class="section-title">ÁREAS ARTÍSTICAS Y CULTURALES</h6>

                    <div class="chip-container">
                        <span class="chip" *ngFor="let option of data.area">
                            {{ option.parameter_detail?.vc_nombre }}
                        </span>
                    </div>
                </div>
                <div class="event-section">
                <h6 class="section-title">SUB ÁREAS</h6>
                    <div class="chip-container">
                        <span class="chip" *ngFor="let option of data.subarea">
                            {{ option.parameter_detail?.vc_nombre }}
                        </span>
                    </div>
                </div> -->
            <div class="event-section" *ngIf="data.characteristics?.lenght > 0">
                <h3 class="section-title">TIPOS DE {{ textDinamico | uppercase }}</h3>
                <div class="chip-container">
                    <span class="chip" *ngFor="let option of data.characteristics">
                        {{ option.parameter_detail.vc_nombre }}
                    </span>
                </div>
            </div>

            <div class="event-section">
                <h3 class="section-title">ETIQUETAS</h3>
                <div class="chip-container">
                    <span class="chip" *ngFor="let option of data.services">
                        {{ option.parameter_detail.vc_nombre | titlecase }}
                    </span>
                </div>
            </div>

            <div class="event-section">
                <h3 class="section-title">EDAD</h3>
                <div class="chip-container">
                    <span class="chip" *ngFor="let edad of vc_edad">
                        {{ edad | titlecase }}
                    </span>
                </div>
            </div>

            <div class="event-section">
                <h3 class="section-title">GRUPOS SOCIALES</h3>
                <div class="chip-container">
                    <span class="chip" *ngFor="let option of data.social_group; let i = index">
                        {{ option.parameter_detail ? option.parameter_detail.vc_nombre : getGrupoEtnico(option.i_fk_id_social_group) }}
                    </span>
                </div>
            </div>

            <div class="event-section">
                <h3 class="section-title">SECTOR SOCIAL</h3>
                <div class="chip-container">
                    <span class="chip" *ngFor="let option of data.social_sector; let i = index">
                        {{ option.parameter_detail ? option.parameter_detail.vc_nombre : getGrupoPoblacional(option.i_fk_id_sector) }}
                    </span>
                </div>
            </div>
            <div class="event-section" *ngIf="data.quotas">
                <h3 class="section-title">CAPACIDAD</h3>
                <div class="chip-container">
                    <span class="chip" *ngFor="let option of data.social_group; let i = index">
                        <div class="box" style="padding: 5px">{{ data.quotas }}&nbsp;personas</div>
                    </span>
                </div>
            </div>
            <div class="event-section" *ngIf="data.schedules">
                <h3 class="section-title">HORARIOS</h3>
                <div class="chip-container">
                    <span class="chip" *ngFor="let horario of data.schedules">
                        <div>
                            <strong>Día:</strong> {{ getDias(horario.day) }} &nbsp; <strong>Inicio:</strong> {{ '1970-01-01T' + horario.startHour | date: 'hh:mm a' }}&nbsp; <strong>Fin:</strong>
                            {{ '1970-01-01T' + horario.endHour | date: 'hh:mm a' }}
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <hr />
        <div class="event-info-card">
            <!-- Modalidad -->
            <div class="info-item">
                <i class="fas fa-warehouse"></i>
                <div>
                    <span class="label">Modalidad</span>
                    <strong>{{ textDinamico | titlecase }}: {{ type_event | titlecase }}</strong>
                </div>
            </div>

            <!-- Ubicación -->
            <div *ngIf="type_event == 'PRESENCIAL' || type_event == 'MIXTO'" class="info-item">
                <i class="fas fa-map-marker-alt"></i>
                <div>
                    <span class="label">Ubicación</span>
                    <p class="m-0"><strong>Dirección:</strong> {{ data.geolocalization.vc_custom_address }}</p>
                    <p class="m-0"><strong>Localidad:</strong> {{ data.geolocalization.vc_locality }}</p>
                    <p class="m-0"><strong>Barrio:</strong> {{ data.geolocalization.vc_neighbourhood }}</p>
                </div>
            </div>

            <!-- Links -->
            <div class="links-group">
                <a *ngIf="data.vc_link_official_page" class="info-link" [href]="data.vc_link_official_page" target="_blank"> <i class="fas fa-globe"></i> Página oficial </a>

                <a *ngIf="data.vc_link_transmission" class="info-link" [href]="data.vc_link_transmission" target="_blank"> <i class="fas fa-video"></i> Ver transmisión </a>

                <a *ngIf="data.vc_link_digital_community" class="info-link" [href]="data.vc_link_digital_community" target="_blank"> <i class="fas fa-users"></i> Comunidad digital </a>
            </div>
        </div>
        <hr />
        <div class="payment-card">
            <!-- Método de pago -->
            <div class="payment-item">
                <i class="fas fa-coins"></i>
                <div>
                    <span class="label">Método de pago</span>
                    <strong>{{ textDinamico | titlecase }}: {{ pay_event | titlecase }}</strong>
                </div>
            </div>

            <!-- Precio -->
            <div *ngIf="vc_price" class="payment-item">
                <i class="fas fa-dollar-sign"></i>
                <div>
                    <span class="label">Precio</span>
                    <strong>{{ vc_price }} COP</strong>
                </div>
            </div>

            <!-- Botón de pago -->
            <a *ngIf="vc_pasarela" class="payment-button text-light" [href]="vc_pasarela" target="_blank">
                <i class="fas fa-credit-card"></i>
                Ir a pagar
            </a>
        </div>
        <hr />
        <div class="extra-info-card">
            <!-- Título -->
            <h3 class="section-title text-primary">Información extra</h3>

            <!-- Texto vacío -->
            <p *ngIf="!descripcionExtra && !descripcion" class="empty-text">Parece que aún no hay detalles extra para este evento.</p>

            <!-- Descripción -->
            <div *ngIf="descripcion" class="extra-text">
                {{ descripcion }}
            </div>

            <div *ngIf="descripcionExtra" class="extra-text">
                {{ descripcionExtra }}
            </div>

            <!-- Contenido multimedia -->
            <div class="media-grid">
                <div class="media-item" *ngFor="let destacUrl of dataDestacado">
                    <iframe [src]="destacUrl" [title]="'Contenido destacado del evento'" allowfullscreen> </iframe>
                </div>

                <div class="media-item" *ngFor="let destacUrl of dataDestacado2">
                    <iframe [src]="destacUrl" [title]="'Contenido destacado del evento'" allowfullscreen> </iframe>
                </div>
            </div>
        </div>
        <hr />
        <div class="event-footer">
            <!-- Fecha de finalización -->
            <div class="end-date">
                <i class="fas fa-hourglass-end"></i>

                <div>
                    <span class="label">Finalización</span>
                    <strong>
                        {{ textDinamico | titlecase }}:
                        {{ data.date?.[0]?.vc_end_date | date: 'fullDate' | titlecase }}
                        - {{ data.date?.[0]?.vc_end_hour }}
                    </strong>
                </div>
            </div>

            <!-- Botón -->
            <a [routerLink]="['/public/home']" class="btn-back text-light" aria-label="Regresar al inicio">
                <i class="fas fa-arrow-left"></i>
                Regresar al inicio
            </a>
        </div>
    </div>
</div>
